import { render } from "./com_usuarios.vue?vue&type=template&id=42a8a5c0&scoped=true"
import script from "./com_usuarios.vue?vue&type=script&lang=js"
export * from "./com_usuarios.vue?vue&type=script&lang=js"

import "./com_usuarios.vue?vue&type=style&index=0&id=42a8a5c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a8a5c0"]])

export default __exports__